import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/admin/developer')({
  component: () => <PageStub title="Developer" description="API console and developer tools" />,
});
